import { derivePrimaryScale, hexToRgba } from '../utils/colorUtils';

/** Chat / Intervene feature primary — OKLCH(55% 0.17 160), WhatsApp-style green. */
export const CHAT_PRIMARY = '#008d4d';

/** @deprecated Use CHAT_PRIMARY — kept for chat token imports. */
export const MACHADALO_PRIMARY = CHAT_PRIMARY;

/** WhatsApp-inspired neutral palette (light mode). */
const FEED_BACKGROUND_LIGHT = '#F0F2F5';
const RECEIVED_BG_LIGHT = '#fdfdfd';
const RECEIVED_TEXT_LIGHT = '#1C1E21';
const RECEIVED_META_LIGHT = '#8A8D91';
const SENT_TEXT_LIGHT = '#FFFFFF';
const SENT_META_LIGHT = 'rgba(255, 255, 255, 0.78)';
const INNER_LABEL_LIGHT = '#667781';
const STATUS_READ_LIGHT = '#53BDEB';
const WHATSAPP_SHADOW = '0 1px 0.5px rgba(11, 20, 26, 0.13)';
const RECEIVED_SHADOW = 'none';

export const whatsappMessageShadow = WHATSAPP_SHADOW;

/**
 * Builds chat message surface tokens from the active primary scale.
 * Sent/outbound colors follow tenant (or Machadalo default) primary.
 * Received/feed surfaces stay neutral for readability.
 */
export function buildChatMessageTokens({
  primaryScale,
  mode = 'light',
  textPrimary,
  textMuted,
  paper,
  surfaceBackground,
}) {
  const receivedBg = mode === 'dark' ? paper : RECEIVED_BG_LIGHT;
  const feedBackground = mode === 'dark' ? surfaceBackground : FEED_BACKGROUND_LIGHT;

  return {
    sent: {
      bg: primaryScale.main,
      text: mode === 'dark' ? primaryScale.contrastText : SENT_TEXT_LIGHT,
      meta:
        mode === 'dark'
          ? hexToRgba(primaryScale.contrastText, 0.72)
          : SENT_META_LIGHT,
      link:
        mode === 'dark'
          ? primaryScale.light
          : hexToRgba('#ffffff', 0.95),
      border: 'transparent',
      statusRead: STATUS_READ_LIGHT,
      shadow: WHATSAPP_SHADOW,
    },
    received: {
      bg: receivedBg,
      text: mode === 'dark' ? textPrimary : RECEIVED_TEXT_LIGHT,
      meta: mode === 'dark' ? textMuted : RECEIVED_META_LIGHT,
      link: primaryScale.main,
      border: 'transparent',
      shadow: RECEIVED_SHADOW,
    },
    inner: {
      label: mode === 'dark' ? 'rgba(255, 255, 255, 0.55)' : INNER_LABEL_LIGHT,
      divider: mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : '#E9EDEF',
      ctaBg: receivedBg,
      ctaBorder: mode === 'dark' ? 'rgba(255, 255, 255, 0.16)' : '#E9EDEF',
      ctaText: primaryScale.main,
      quoteBorder: primaryScale.main,
      quoteBg: mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#F0F2F5',
    },
    feed: {
      background: feedBackground,
      dateSeparator: mode === 'dark' ? 'rgba(255, 255, 255, 0.45)' : INNER_LABEL_LIGHT,
    },
  };
}

/**
 * Static chat.message defaults for semantic.js (Machadalo green primary).
 */
export function buildDefaultChatMessageTokens(text, surfaces) {
  const primaryScale = derivePrimaryScale(CHAT_PRIMARY, 'light');

  return buildChatMessageTokens({
    primaryScale,
    mode: 'light',
    textPrimary: text.primary,
    textMuted: text.muted,
    paper: surfaces.surface,
    surfaceBackground: surfaces.background,
  });
}
